// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".progress-inner-container{\n    width: 80px;\n    height: 150px;\n\n}\n.progress-image-div{\n    position:absolute;\n   \nheight: 100%;\nwidth: 100%;\ndisplay: flex;\njustify-content: center;\nalign-items: center;\n}\n.progress-image-div img{\n    height: 30px;\n    width: 25px;\n    \n}", ""]);
// Exports
module.exports = exports;
